<template>
  <div class="page-content device" :class="groupDialogVisible || detailDialogVisible ? 'overhide' : ''">
    <h1 class="page-title">{{ $locale('sideMenu.settings.devices') }}</h1>

    <!-- Search Area -->
    <el-row :gutter="10" class="search-area">
      <el-col class="makeInline" :lg="12" :md="18">
            <el-input :placeholder="$locale('form.plsEnterYourName')" v-model="filter.name" @keyup.enter.native="searchDevice" class="searchMaxWidth makeLeft">
              <i slot="suffix" class="el-input__icon el-icon-search" @click="searchDevice"></i>
            </el-input>
            <el-button class="egl-btn-yellow makeLeft" @click="searchDevice">{{ $locale("global.search") }}</el-button>
      </el-col>
      <el-col class="ta-r" :lg="12" :md="6">
        <el-button
          :class="deviceApproveList.length > 0 ? 'egl-btn-yellow' : 'egl-btn-gray'"
          :disabled="!(deviceApproveList.length > 0)"
          @click="approveDevice_fn"
        >{{ $locale("global.approve") }}</el-button>
      </el-col>
    </el-row>

    <el-table :data="deviceTable" class="egl-table list-table" stripe>
      <el-table-column :label="$locale('global.change')" width="70" align="center">
        <template slot-scope="scope">
          <i class="el-icon-circle-check change" v-if="!scope.row.isApprove"></i>
        </template>
      </el-table-column>

      <el-table-column
        v-for="th in deviceThead"
        :label="th.text"
        :prop="th.prop"
        :key="th.prop"
        :align="th.align"
        :width="th.width"
      ></el-table-column>

      <el-table-column :label="$locale('global.control')" align="center" width="110">
        <template slot-scope="scope">
          <div class="handle">
            <a @click="editDevice(scope.$index, scope.row.id)">{{ $locale("global.edit") }}</a>
            <!-- <el-divider direction="vertical"></el-divider> -->
            <!-- <a @click="deleteDevice_fn(scope.row.id, scope.$index, scope.row.name)">{{ $locale("global.delete") }}</a> -->
          </div>
        </template>
      </el-table-column>
    </el-table>

    <div class="table-module info-supplement-container">
      <h3 class="info-title">{{ $locale('global.groupDisplay') + '（' + $locale('global.POS') + '）' }}</h3>

      <!-- Search Area -->
      <el-row :gutter="10" class="search-area">
        <el-col class="makeInline" :lg="12">
              <el-input :placeholder="$locale('form.plsEnterYourName')" v-model="groupFilter.name" @keyup.enter.native="searchGroup" class="searchMaxWidth">
                <i slot="suffix" class="el-input__icon el-icon-search" @click="searchGroup"></i>
              </el-input>
              <el-button class="egl-btn-yellow makeLeft" @click="searchGroup">{{ $locale("global.search") }}</el-button>
        </el-col>
        <el-col class="ta-r" :lg="12">
          <!-- <el-button
            :class="groupApproveList.length > 0 ? 'egl-btn-yellow' : 'egl-btn-gray'"
            :disabled="!(groupApproveList.length > 0)"
            @click="approveGroup_fn"
          >{{ $locale("global.approve") }}</el-button> -->
          <el-button class="egl-btn-yellow" @click="showGroupDialog('')">{{ $locale("global.create") }}</el-button>
        </el-col>
      </el-row>

      <div class="device-group-table">
        <ul class="table-tab clearfix">
          <li v-for="(tab, index) in groupTab" :key="index" :class="index == groupTabIndex ? 'act' : ''" @click="groupTabChange(index)">{{ tab.text }}</li>
        </ul>

        <div class="group-table-box">
          <el-table :data="groupTableData" class="egl-table list-table" @sort-change="groupSort_fn">
            <!-- <el-table-column :label="$locale('global.change')" width="70" align="center">
              <template slot-scope="scope">
                <i class="el-icon-circle-check change" v-if="!scope.row.isApprove"></i>
              </template>
            </el-table-column> -->

            <el-table-column :label="$locale('global.name')" prop="name" sortable="custom" min-width="500"></el-table-column>
            <el-table-column :label="$locale('global.order')" prop="sort" sortable="custom" min-width="200"></el-table-column>

            <el-table-column :label="$locale('global.control')" align="center" width="120">
              <template slot-scope="scope">
                <div class="handle">
                  <a @click="showGroupDialog(scope.row.id)"> {{ $locale("global.edit") }}</a>
                  <template v-if="scope.row.canDelete">
                    <el-divider direction="vertical"></el-divider>
                    <a @click="deleteGroup_fn(scope.row.id, scope.$index, scope.row.name)">{{ $locale("global.delete") }}</a>
                  </template>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>

    <div class="table-module info-supplement-container">
      <h3 class="info-title">{{ $locale('global.groupDisplay') + '（' + $locale('global.consumerCashRegister') + '）' }}</h3>

      <!-- Search Area -->
      <el-row :gutter="10" class="search-area">
        <el-col class="makeInline" :lg="12">
              <el-input :placeholder="$locale('form.plsEnterYourName')" v-model="groupFilter.scName" @keyup.enter.native="searchSCGroup(groupFilter.scName)" class="searchMaxWidth">
                <i slot="suffix" class="el-input__icon el-icon-search" @click="searchSCGroup(groupFilter.scName)"></i>
              </el-input>
              <el-button class="egl-btn-yellow makeLeft" @click="searchSCGroup(groupFilter.scName)">{{ $locale("global.search") }}</el-button>
        </el-col>
        <el-col class="ta-r" :lg="12">
          <!-- <el-button
            :class="groupApproveList.length > 0 ? 'egl-btn-yellow' : 'egl-btn-gray'"
            :disabled="!(groupApproveList.length > 0)"
            @click="approveGroup_fn"
          >{{ $locale("global.approve") }}</el-button> -->
          <el-button class="egl-btn-yellow" @click="showGroupDialog('', true)">{{ $locale("global.create") }}</el-button>
        </el-col>
      </el-row>

      <div class="device-group-table">
        <ul class="table-tab clearfix">
          <li v-for="(tab, index) in [{
          text: $locale('setting.device.grouptab.consession'),
          type: 'concessionCsc'
        }]" :key="index" class="act">{{ tab.text }}</li>
        </ul>

        <div class="group-table-box">
          <el-table :data="SCgroupTableData" class="egl-table list-table" @sort-change="scGroupSort_fn">
            <!-- <el-table-column :label="$locale('global.change')" width="70" align="center">
              <template slot-scope="scope">
                <i class="el-icon-circle-check change" v-if="!scope.row.isApprove"></i>
              </template>
            </el-table-column> -->

            <el-table-column :label="$locale('global.name')" prop="name" sortable="custom" min-width="500"></el-table-column>
            <el-table-column :label="$locale('global.order')" prop="sort" sortable="custom" min-width="200"></el-table-column>

            <el-table-column :label="$locale('global.control')" align="center" width="120">
              <template slot-scope="scope">
                <div class="handle">
                  <a @click="showGroupDialog(scope.row.id, true)"> {{ $locale("global.edit") }}</a>
                  <template v-if="scope.row.canDelete">
                    <el-divider direction="vertical"></el-divider>
                    <a @click="deleteGroup_fn(scope.row.id, scope.$index, scope.row.name)">{{ $locale("global.delete") }}</a>
                  </template>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>

    <hr class="dotted" />
    <div class="form-module-tit">{{ $locale('setting.device.trailer') }}</div>
    <el-form class="egl-elm egl-detail" :model="idleSetting" ref="idleSettingForm" label-position="top">
      <el-row>
        <el-col>
          <el-form-item label="URL">{{ getUrl(cinemaId) }}</el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="3">
          <el-form-item :label="$locale('setting.cinema.trailer.use')" prop="useTrailer" >
            <el-select v-model="idleSetting.useScsTrailer">
              <el-option :value="true" :label="$locale('global.yes')" />
              <el-option :value="false" :label="$locale('global.no')" />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="4">
          <el-form-item  prop="trailerWaitTime" >
            <span slot="label" class="makeInline">{{ $locale('setting.cinema.trailer.waitTime') }}</span>
            <el-input
              placeholder="60"
              v-model="idleSetting.scsTrailerWaitTime"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10" v-for="(item, idx) in idleSetting.scsTrailersVideo" :key="'trailer' + idx">
        <el-col :span="2" :style="{ visibility: idx === 0 ? 'visible' : 'hidden' }">
          <el-form-item :label="$locale('setting.cinema.trailer.type')">{{ $locale('setting.cinema.trailer.option1') }}</el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$locale('setting.cinema.trailer.link')" props="link">
            <el-input :key="idx" v-model="item.link" :placeholder="$locale('setting.cinema.trailer.link.p')"/>
          </el-form-item>
        </el-col>
        <el-col :span="3">
          <el-form-item :label="$locale('global.order')">
            <el-input v-model.number="item.order" placeholder="1"/>
          </el-form-item>
        </el-col>
        <el-col :span="2" :style="{ 'display':'flex'}" >
          <div class="operation" v-if="idleSetting.scsTrailersVideo.length > 1" @click="removeItem('scsTrailersVideo', idx)">
            <i class="el-icon-minus"></i>
          </div>
          <div class="operation" v-if="idx === idleSetting.scsTrailersVideo.length - 1" @click="add('scsTrailersVideo')">
            <i class="el-icon-plus"></i>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="10" v-for="(item, idx) in idleSetting.scsTrailersImg" :key="'photograph' + idx">
        <el-col :span="2" :style="{ visibility: idx === 0 ? 'visible' : 'hidden' }">
          <el-form-item :label="$locale('setting.cinema.trailer.type')">{{ $locale('setting.cinema.trailer.option2') }}</el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item props="link">
            <UploadContainer
              :imageList="[item.link]"
              @onSuccess="({response}) => onSuccess(response, idx)"
              @onDelete="removeUpload(idx)"
            ></UploadContainer>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item props="disylayTime">
            <span class="makeInline" slot="label">{{ $locale('setting.cinema.trailer.displaytime') }}</span>
            <el-input v-model.number="item.displayTime" placeholder="60"/>
          </el-form-item>
        </el-col>
        <el-col :span="3">
          <el-form-item :label="$locale('global.order')">
            <el-input v-model.number="item.order" placeholder="1"/>
          </el-form-item>
        </el-col>
        <el-col :span="2" :style="{ 'display':'flex'}" >
          <div class="operation" v-if="idleSetting.scsTrailersImg.length > 1" @click="removeItem('scsTrailersImg', idx)">
            <i class="el-icon-minus"></i>
          </div>
          <div class="operation" v-if="idx === idleSetting.scsTrailersImg.length - 1" @click="add('scsTrailersImg')">
            <i class="el-icon-plus"></i>
          </div>
        </el-col>
      </el-row>
    </el-form>
    <div class="detail-page-btn">
      <el-button class="egl-btn-yellow" @click="save_fn">{{ $locale("global.confirm") }}</el-button>
    </div>
    <!--v-bind:payTypeList="payTypeList"-->
    <DeviceDialog
      v-bind:actionVisible="detailDialogVisible"
      v-bind:detailObj="deviceDetailObj"
      v-bind:paymentTypeList="paymentTypeList"
      @closeFn="closeDetailDialog"
      @returnMsg="getDeviceDialogMsg"
      v-bind:isEdit="isEdit"
      ref="dialog"
    ></DeviceDialog>

    <GroupDialog
      v-bind:action="groupAction"
      v-bind:actionVisible="groupDialogVisible"
      v-bind:detailObj="groupDetailObj"
      @closeFn="closeGroupDialog"
      @returnMsg="getGroupDialogMsg"
    ></GroupDialog>
  </div>
</template>
<style scoped>
.makeInline {
  white-space: nowrap;
}
.searchMaxWidth {
  max-width: 350px;
}
.makeLeft {
  margin-left: 10px;
}
.el-col {
  margin-bottom: 5px;
}
</style>
<script>
import DeviceDialog from "@/components/Device/Dialog.vue";
import GroupDialog from "@/components/Device/GroupDialog.vue";
import "@/assets/style/device.less";
import "@/assets/style/cinema.less";
import {
  getDeviceList,
  getGroupList,
  createGroup,
  updateGroup,
  deleteGroup,
  approveGroup,
  getPaymentTypeList,
  getPayTypeList,
  deleteDevice,
  updateDevice,
  approveDevice,
  getDeviceDetail
} from "@/helpers/service/api/device.js";
import { getCscTrailerService, updateCscTrailerService } from "@/helpers/service/api/cinema";
import { requestAll } from "@/helpers/service/axiosPlugin";
import countDownAlert from "@/utils/countDownAlert";
import UploadContainer from "@/components/common/UploadContainer";

export default {
  name: "device",
  data() {
    return {
      cinemaId: window.localStorage.getItem("cinemaId"),
      onSearch: {
        name: "",
        page: 0,
        pageSize: 9999
      },
      filter: {
        name: "",
      },
      isEdit: true,
      detailDialogVisible: false,
      deviceTable: [],
      deviceThead: [],
      deviceDetailObj: {},
      deviceApproveList: [],

      groupFilter: {
        name: "",
        scName: "",
      },
      groupSort: {
        sort: "",
        sortKey: "",
        scSort: "",
        scSortKey: "",
      },
      groupOnSearch: {
        name: "",
        page: 0,
        pageSize: 9999
      },
      groupData: [],
      groupTableData: [],
      SCgroupTableData: [],
      groupApproveList: [],
      groupTab: [
        {
          text: this.$locale("setting.device.grouptab.ticket"),
          type: "ticketType"
        },
        {
          text: this.$locale("setting.device.grouptab.consession"),
          type: "concession"
        },
        {
          text: this.$locale("setting.device.grouptab.commercial"),
          type: "commercial"
        },
        {
          text: this.$locale("setting.device.grouptab.set"),
          type: "goodsPackage"
        },
        {
          text: this.$locale("setting.device.grouptab.coupon"),
          type: "coupon"
        }
      ],
      groupTabIndex: 0,
      groupAction: "create",
      groupDialogVisible: false,
      groupDetailObj: {},

      paymentTypeList: [],
      isSC: false,
      idleSetting: {
        useScsTrailer: true,
        scsTrailerWaitTime: 0,
        scsTrailersVideo: [
          {
            link: "",
            order: 0,
          }
        ],
        scsTrailersImg: [ {
          link: "",
          displayTime: 0,
          order: 0,
        } ],
        // trailerList: [
        //   {
        //     displayTime: 0,
        //     link: "",
        //     order: 0,
        //     type: 0
        //   }
        // ]

      },
      total: 1,

      //payTypeList: [],
    };
  },
  methods: {
    closeDetailDialog() {
      this.detailDialogVisible = false;
      // this.updateDeviceList();
    },
    closeGroupDialog() {
      this.groupDialogVisible = false;
    },
    createDeviceThead() {
      let arr = [
        {
          prop: "name",
          text: this.$locale("global.name"),
          width: 360,
        },
        /*{
          prop: "id",
          text: this.$locale("setting.device.id"),
          width: 260,
        },*/
        {
          prop: "deviceType",
          text: this.$locale("setting.device.devicetype"),
          align: "center",
        },
        /*{
          prop: "createTimeText",
          text: this.$locale("setting.device.createtime"),
        }*/
      ];

      return arr;
    },
    getDeviceList_fn() {
      let obj = { ...this.onSearch };

      obj.cinemaId = this.cinemaId;

      return getDeviceList(obj, false, false);
    },
    getGroupList_fn() {
      let obj = { ...this.groupOnSearch };

      obj.cinemaId = this.cinemaId;

      if (this.groupSort.sortKey != "") {
        obj.sort = this.groupSort.sort;
        obj.sortKey = this.groupSort.sortKey;
      }

      return getGroupList(obj, false, false);
    },
    getPaymentTypeList_fn() {
      let obj = {
        cinemaId: this.cinemaId,
        forPos: true,
        page: 0,
        pageSize: 9999
      };

      return getPaymentTypeList(obj, false, false);
    },
    getPayTypeList_fn() {
      let obj = {
        cinemaId: this.cinemaId,
        page: 0,
        pageSize: 9999
      };

      return getPayTypeList(obj, false, false);
    },
    formatData(deviceList) {
      let approveList = [];

      deviceList.map(obj => {
        obj.createTimeText = this.$moment(obj.createTime).format("YYYY-MM-DD HH:mm:ss");
        if (!obj.isApprove) {
          approveList.push(obj.id);
        }
      });

      this.deviceTable = deviceList;
      this.deviceApproveList = approveList;
    },
    firstLoading() {
      const that = this;
      let cinemaId = window.localStorage.getItem("cinemaId") || "";

      if (cinemaId == "") {
        that.$emit("callCinema", "firstLoading");

        return;
      }
      that.cinemaId = cinemaId;

      requestAll([
        that.getDeviceList_fn(),
        that.getGroupList_fn(),
        that.getPaymentTypeList_fn(),
        //that.getPayTypeList_fn()
      ]).then(res => {
        that.formatData(res[0].data.data);
        that.groupListSplit(res[1].data);
        that.paymentTypeList = res[2].data.data;
        //that.payTypeList = res[3].data.data;
      });
    },
    upGroupList() {
      requestAll([ this.getGroupList_fn() ])
        .then(res => {
          this.groupListSplit(res[0].data);
        });
    },
    groupListSplit(groupList = this.groupData) {
      let { type } = this.groupTab[this.groupTabIndex];
      let arr = [];
      let approveList = [];

      groupList.map(obj => {
        if (obj.type == type) {
          arr.push({ ...obj });
          if (!obj.isApprove) {
            approveList.push(obj.id);
          }
        }
      });

      this.groupData = groupList;
      this.groupTableData = arr;
      this.SCgroupTableData = groupList.filter(item => item.type === "concessionCsc");
      this.groupApproveList = approveList;
    },
    updateDeviceList() {
      requestAll([ this.getDeviceList_fn() ])
        .then(res => {
          this.formatData(res[0].data.data);
        });
    },
    searchDevice() {
      this.onSearch = { ...this.onSearch, ...this.filter };
      this.updateDeviceList();
    },
    searchGroup() {
      this.groupOnSearch = { ...this.groupOnSearch, ...this.groupFilter };
      this.upGroupList();
    },
    getSCGroupList(name, sort) {
      getGroupList({
        cinemaId: window.localStorage.getItem("cinemaId"),
        type: "concessionCsc",
        ...name ? { name: this.groupFilter.scName } : {},
        ...sort.scSort ? { sort: sort.scSort } : {},
        ...sort.scSortKey ? { sortKey: sort.scSortKey } : {},
        page: 0,
        pageSize: 99999,
      }).then(res => {
        if (res.data && res.data.length > 0) {
          this.SCgroupTableData = res.data;
        }
      });
    },
    searchSCGroup(name) {
      this.getSCGroupList(name);
    },
    editDevice(index, id) {
      getDeviceDetail({ id }).then(res => {
        this.isEdit = res.data.edit;
        // this.deviceDetailObj = { ...this.deviceTable[index] };
        this.deviceDetailObj = { ...res.data };
        this.detailDialogVisible = true;
      });
    },
    deleteDevice_fn(id, index, name) {
      const that = this;
      let confirmHtml = `<i class="egl-confirm-question">?</i><span class="result-text">${this.$locale("global.delete")} ${name}</span>`;

      this.$confirm(confirmHtml, "", {
        dangerouslyUseHTMLString: true,
        showClose: false,
        showCancelButton: true,
        cancelButtonClass: "egl-btn-white",
        cancelButtonText: this.$locale("global.cancel"),
        showConfirmButton: true,
        confirmButtonClass: "egl-btn-yellow",
        confirmButtonText: this.$locale("global.delete"),
        customClass: "egl-confirm",
        closeOnClickModal: false,
      }).then(() => {
        deleteDevice({ id }).then(res => {
          if (res.success) {
            let arr = [ ...that.deviceTable ];
            arr.splice(index, 1);

            that.countDown(this.$locale("global.deleteSuccessfully"));
            that.deviceTable = arr;
          }
        }).catch(() => {});
      }).catch(() => {});
    },
    getDeviceDialogMsg(obj) {
      const that = this;

      updateDevice({ deviceInfo: obj }).then(res => {
        if (res.success) {
          that.countDown(this.$locale("global.updateSuccessfully"));
          that.detailDialogVisible = false;
          that.updateDeviceList();
        }
      }).catch(() => {});
    },
    showApprove() {
      this.$refs.approve.toggleApprove();
    },
    approveDevice_fn() {
      if (this.deviceApproveList.length > 0) {
        approveDevice({ cinemaId: this.cinemaId })
          .then(res => {
            if (res.success) {
              this.updateDeviceList();
            }
          })
          .catch(() => {});
      }
    },
    showGroupDialog(id = "", isSC = false) {
      let obj = {};
      let action = "";
      this.isSC = isSC;
      if (id == "") {
        action = "create";
      } else {
        action = "edit";
        const arr = isSC ? this.SCgroupTableData : this.groupTableData;
        console.log('arr', arr);
        for (let i = 0; i < arr.length; i++) {
          if (id == arr[i].id) {
            obj = { ...arr[i] };
            break;
          }
        }
      }

      this.groupAction = action;
      this.groupDetailObj = { ...obj };
      this.groupDialogVisible = true;
    },
    getGroupDialogMsg(obj) {
      const that = this;
      let type = this.isSC ? "concessionCsc" : that.groupTab[that.groupTabIndex].type;
      let pars = { ...obj, type, cinemaId: that.cinemaId };

      if (obj.id) {
        updateGroup(pars)
          .then(res => {
            if (res.success) {
              that.countDown(that.$locale("global.updateSuccessfully"));
              that.groupDialogVisible = false;
              that.upGroupList();
            }
          })
          .catch(() => {});
      } else {
        createGroup(pars)
          .then(res => {
            if (res.success) {
              that.countDown(this.$locale("global.createSuccessfully"));
              that.groupDialogVisible = false;
              that.upGroupList();
            }
          })
          .catch(() => {});
      }
    },
    groupTabChange(index) {
      if (index != this.groupTabIndex) {
        this.groupTabIndex = index;
        this.groupListSplit();
      }
    },
    deleteGroup_fn(id, index, name) {
      const that = this;
      let confirmHtml = `<i class="egl-confirm-question">?</i><span class="result-text">${this.$locale("global.delete")} ${name}</span>`;

      this.$confirm(confirmHtml, "", {
        dangerouslyUseHTMLString: true,
        showClose: false,
        showCancelButton: true,
        cancelButtonClass: "egl-btn-white",
        cancelButtonText: this.$locale("global.cancel"),
        showConfirmButton: true,
        confirmButtonClass: "egl-btn-yellow",
        confirmButtonText: this.$locale("global.delete"),
        customClass: "egl-confirm",
        closeOnClickModal: false,
      }).then(() => {
        deleteGroup({ id }).then(res => {
          if (res.success) {
            let arr = [ ...that.groupTableData ];
            arr.splice(index, 1);

            that.countDown(this.$locale("global.deleteSuccessfully"));
            that.groupTableData = arr;
          }
        }).catch(() => {});
      }).catch(() => {});
    },
    approveGroup_fn() {
      if (this.groupApproveList.length > 0) {
        approveGroup({ cinemaId: this.cinemaId })
          .then(res => {
            if (res.success) {
              this.upGroupList();
            }
          })
          .catch(() => {});
      }
    },
    groupSort_fn({ prop, order }) {
      let sort = "";
      let sortKey = "";

      if (order == "ascending") {
        sort = "ASC";
        sortKey = prop;
      }

      if (order == "descending") {
        sort = "DESC";
        sortKey = prop;
      }

      this.groupSort = { sort, sortKey };
      this.upGroupList();
    },
    scGroupSort_fn({ prop, order }) {
      let sort = "";
      let sortKey = "";

      if (order == "ascending") {
        sort = "ASC";
        sortKey = prop;
      }

      if (order == "descending") {
        sort = "DESC";
        sortKey = prop;
      }
      this.groupSort = { scSort: sort, scSortKey: sortKey };
      this.getSCGroupList("", { scSort: this.groupSort.scSort, scSortKey: this.groupSort.scSortKey });
    },
    countDown(str = `${this.$locale("global.createSuccessfully")}`) {
      countDownAlert({
        content: str,
        callback: () => {
          this.firstLoading();
        }
      });
    },
    onSuccess(res, idx) {
      this.idleSetting.scsTrailersImg[idx].link = res.data;
    },
    removeUpload(idx) {
      this.idleSetting.scsTrailersImg[idx].link = "";
    },
    add(type) {
      this.idleSetting[type].push({
        link: "",
        ...type === "scsTrailersImg" ? { displayTime: 0 } : {},
        order: 0,
      });
    },
    removeItem(type, idx) {
      this.idleSetting[type].splice(idx, 1);
    },
    getCscTrailer() {
      getCscTrailerService({
        id: window.localStorage.getItem("cinemaId")
      }).then(res => {
        if (res.data) {
          this.idleSetting = {
            ...res.data,
            scsTrailersVideo: res.data.scsTrailersVideo && res.data.scsTrailersVideo.length > 0
              ? res.data.scsTrailersVideo : [ {
                link: "",
                order: 0,
              } ],
            scsTrailersImg: res.data.scsTrailersImg && res.data.scsTrailersImg.length > 0
              ? res.data.scsTrailersImg : [ {
                link: "",
                displayTime: 0,
                order: 0,
              } ],
          };
        }
      });
    },
    save_fn() {
      updateCscTrailerService({
        cinemaScsTrailer: this.idleSetting,
        cinemaId: window.localStorage.getItem("cinemaId")
      }).then(res => {
        if (res.success) {
          countDownAlert({
            content: this.$locale("global.operationSuccessful"),
            callback: () => {
              this.getCscTrailer();
            }
          });
        }
      });
    },
    getUrl(cinemaId) {
      const curUrl = window.location.hostname;
      if (curUrl.indexOf("dev") > -1 || curUrl.indexOf("local") > -1) {
        return `https://kitchen-dev.eigaland.com?cinemaId=${cinemaId}`;
      } else if (curUrl.indexOf("uat") > -1) {
        return `https://kitchen-uat.eigaland.com?cinemaId=${cinemaId}`;
      }
      return `https://kitchen.eigaland.com?cinemaId=${cinemaId}`;
    }
  },
  mounted() {
    this.deviceThead = this.createDeviceThead();
    this.firstLoading();
    this.getCscTrailer();
  },
  components: {
    DeviceDialog,
    GroupDialog,
    UploadContainer,
  }
};
</script>
